import { render, staticRenderFns } from "./LookForPwd.vue?vue&type=template&id=10d3126d&"
import script from "./LookForPwd.vue?vue&type=script&lang=js&"
export * from "./LookForPwd.vue?vue&type=script&lang=js&"
import style0 from "./LookForPwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports